import script from "./withIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./withIcon.vue?vue&type=script&setup=true&lang=ts"

import "./withIcon.vue?vue&type=style&index=0&id=1c4f6250&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c4f6250"]])

export default __exports__